/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Col_NameInputs */

const vi_shop_account_col_name = /** @type {(inputs: Shop_Account_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Họ tên`)
};

/**

* @param {Shop_Account_Col_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_col_name = /** @type {((inputs?: Shop_Account_Col_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Col_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_col_name(inputs)
});